import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    transition: 'all 100ms ease-in-out',
  },
  child: {
    marginTop: 15,
    backgroundColor: theme.palette.divider,
    width: '60%',
    borderRadius: theme.shape.borderRadius * 2,
    borderBottomRightRadius: 0,
    padding: 15,
    paddingBottom: 12,
    '& h4': {
      color: theme.palette.primary.main,
    },
    '& p': {
      color:
        theme.palette.type === 'dark' ? '#fff' : theme.palette.text.primary,
    },
    '@media (min-width: 1441px)': {
      width: '45%',
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.hover2}`,
    paddingBottom: 7,
    marginBottom: 7,
  },
  actions: {
    marginTop: 15,
    marginRight: 5,
    width: 35,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  bookmarked: {
    marginTop: 22,
    marginRight: 14,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    transition: 'all 100ms ease-in-out',
  },
  picture: {
    margin: 0,
    padding: 0,
    marginTop: 10,
    width: '100%',
    cursor: 'pointer',
    borderRadius: theme.shape.borderRadius,
  },
  private: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 10,
    padding: '3px 8px 2px 8px',
    color: '#fff',
    textTransform: 'uppercase',
    backgroundColor: theme.palette.background.paper2,
    borderRadius: 2,

    '& svg': {
      width: 14,
      marginRight: 8,
      fill: theme.palette.type === 'dark' ? '#fff' : '#1c3059',
    },
  },
}))

export default useStyles
